import type { ControllerRenderProps } from 'react-hook-form'
import type { ChangeEvent, Dispatch, SetStateAction } from 'react'
import type { BranchForForm } from 'types'

import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Loader, TextInput } from 'components'
import { trimFirstSpace } from 'helpers/common'
import * as utils from 'helpers/getAddress'

interface IInputAddress {
  isAddressChecking: boolean
  setIsAddressChecking: Dispatch<SetStateAction<boolean>>
  field: ControllerRenderProps
}

export const InputAddress: React.FC<IInputAddress> = (props) => {
  const { errors, setValue, watch, trigger, getValues } =
    useFormContext<BranchForForm>()

  const { isSameAsCompany } = watch(['isSameAsCompany'])
  const { t } = useTranslation(['common'])

  const onChangeAddress = (
    e: ChangeEvent<HTMLInputElement>,
    field: ControllerRenderProps,
  ) => {
    field.onChange(trimFirstSpace(e))
  }

  const onBlurAddress = async () => {
    props.setIsAddressChecking(true)
    setValue('address', getValues('address').trim())
    await trigger('address')
    props.setIsAddressChecking(false)
  }

  const isErrorAddress = (field: ControllerRenderProps) =>
    utils.handleIsError(
      isSameAsCompany,
      field.value,
      Boolean(errors.address?.message),
    )

  const errorMsgAddress = (field: ControllerRenderProps) =>
    utils.getErrorMsg(field.value, errors.address?.message, isSameAsCompany)

  return (
    <TextInput
      value={props.field.value}
      onChange={(e) => onChangeAddress(e, props.field)}
      onBlur={onBlurAddress}
      placeholder={t('common:address.placeholder')}
      isError={isErrorAddress(props.field)}
      disabled={isSameAsCompany}
      message={errorMsgAddress(props.field)}
      maxLength={100}
      withIcon={props.isAddressChecking && <Loader />}
      ref={props.field.ref}
    />
  )
}
